import React from "react";
import { Row, Col, Typography, Button, Space, Grid } from "antd";
import Ai from "../../assets/images/Ai.svg";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function AISection() {
  const screens = useBreakpoint();

  return (
    <>
      {/* AI SECTION */}
      <div
        style={{
          background: "#2b1f5f",
          padding: screens.md ? "80px 64px" : "40px 24px",
        }}
      >
        <Row
          align="middle"
          gutter={[48, 48]}
          justify="center"
          style={{ maxWidth: 1400, margin: "0 auto" }}
        >
          {/* LEFT IMAGE */}
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={Ai}
              alt="AI Illustration"
              style={{
                width: "100%",
                maxWidth: 552,
                height: "auto",
                display: "block",
              }}
            />
          </Col>

          {/* RIGHT CONTENT */}
          <Col xs={24} md={12}>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Title level={2} style={{ color: "#fff" }}>
                Launching a website is easier with AI
              </Title>

              <Text style={{ color: "#ddd" }}>
                • Get a ready-to-launch website with our AI-integrated Hostinger
                blog theme.
              </Text>

              <Text style={{ color: "#ddd" }}>
                • Generate unique and SEO-friendly content using the AI
                assistant plugin.
              </Text>

              <Text style={{ color: "#ddd" }}>
                • Save time – let AI select <strong>relevant images</strong> for
                your content.
              </Text>
            </Space>
          </Col>
        </Row>
      </div>

      {/* CTA SECTION */}
      <div
        style={{
          background: "#ffffff",
          padding: screens.md ? "64px 24px" : "40px 16px",
          textAlign: "center",
        }}
      >
        <Space direction="vertical" size="middle">
          <Title level={2} style={{ marginBottom: 0 ,color:'#2d1e6b'}}>
            Unlock the Power of Managed Web Hosting
          </Title>

          <Button
            type="primary"
            size="large"
            style={{
              background: "#4f57f6",
              borderRadius: 8,
              padding: "0 32px",
              height: 44,
            }}
          >
            Get started
          </Button>

          <Text type="secondary" style={{ fontSize: 13 }}>
            30-Day Money-Back Guarantee
          </Text>
        </Space>
      </div>
    </>
  );
}
